import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { GetSupportedVersionsResponse, Platform, UpdateVersionRequest } from 'src/app/services/dtos';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
	templateUrl: './version-page.component.html',
	styleUrls: ['./version-page.component.scss'],
	providers: [NotificationService],
})
export class VersionPageComponent implements OnInit {
	versions: GetSupportedVersionsResponse;
	newVersions: UpdateVersionRequest;
	currentEditedPlatform: Platform;
	constructor(private apiService: ApiService, private notificationService: NotificationService) {}

	ngOnInit() {
		this.updateVersionPage();
	}

	updateVersionPage() {
		this.apiService.getVersions().subscribe((versions) => {
			this.versions = versions;
		});
		this.currentEditedPlatform = null;
	}

	showVersionDialog(platform: Platform) {
		this.currentEditedPlatform = platform;
	}

	updateVersion() {
		this.newVersions =
			this.currentEditedPlatform === 'ANDROID'
				? {
						minimum: this.versions.android.minimum,
						platform: this.currentEditedPlatform,
						recommended: this.versions.android.recommended,
				  }
				: {
						minimum: this.versions.ios.minimum,
						platform: this.currentEditedPlatform,
						recommended: this.versions.ios.recommended,
				  };
		this.apiService.putVersions(this.newVersions).subscribe(
			() => {
				this.notificationService.notifySuccess('Mise à jour réussie');
				this.updateVersionPage();
			},
			(err) => {
				this.notificationService.notifyError(err.statusText);
				this.updateVersionPage();
			},
		);
	}
}
